<div class="search-root">
    <input [class.input--not-empty]='!!value' [(ngModel)]="value" (ngModelChange)="onChanges($event)" />

    <span class="placeholder">
        {{'CURRENCY_FILTER.FILTER_PLACEHOLDER' | translate}}
        <img src="/assets/images/icons/filter.svg" alt="" />
    </span>

</div>
